import { Component, OnInit } from '@angular/core';
import { LogService } from 'src/app/core/log.service';

@Component({
  selector: 'app-debugger-panel',
  templateUrl: './debugger-panel.component.html',
  styleUrls: ['./debugger-panel.component.scss'],
})
export class DebuggerPanelComponent {
  messages: { [key: string]: any }[] = [];

  constructor(private logService: LogService) {
    this.logService.setDebuggerComponent(this);
  }

  logMessage(type: 'log' | 'error', ...params: any[]): void {
    let messages = [`[${type.toUpperCase()}]`];

    const objects = params.map((param) => {
      let parsed;

      try {
        if (param === 'string') {
          parsed = JSON.parse(`${param}`);
        } else {
          if (param instanceof Error) {
            parsed = {
              value: `name: ${param.name} 
            Message: ${param.message}`,
              stack: param.stack,
            };
          } else {
            parsed = JSON.parse(JSON.stringify(param));
          }
        }
      } catch (error) {
        parsed = param || 'undefined value';
      }

      return parsed;
    });

    messages = [...messages, ...objects];

    const result: { [key: string]: any } = {};

    messages.forEach((message, index) => {
      result[`${index}`] = message;
    });

    this.messages.push(result); // Add to messages array
  }
}
